export default __webpack_public_path__ + "8f76de820c06c66dbaad2f9292539527.png";